package com.wintermar.inspection.feature.presentation.inspection.landing.widget.choose_template

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.input.InputSearchText
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.util.SelectionModel
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.choose_template_before_start_inspection
import inspection.composeapp.generated.resources.ic_check
import inspection.composeapp.generated.resources.icon_content_description
import inspection.composeapp.generated.resources.not_found
import kotlinx.coroutines.FlowPreview
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@OptIn(FlowPreview::class)
@Composable
fun ChooseTemplate(
    templates: List<SelectionModel>,
    topPadding: Dp = 0.dp,
    selectedTemplate: SelectionModel? = null,
    isEmptyChooseTemplate: Boolean = false,
    onSelectedItem: (SelectionModel) -> Unit,
) {
    val dimension = LocalAppTheme.current.dimension
    val color = LocalAppTheme.current.color
    val focusManager = LocalFocusManager.current
    var filteredItems by remember { mutableStateOf(templates) }
    var selectedItem by remember { mutableStateOf(selectedTemplate) }

    fun handleSelectedItem(item: SelectionModel) {
        focusManager.clearFocus()
        selectedItem = item
        onSelectedItem(item)
    }

    fun handleKeywordChanged(keyword: CharSequence) {
        filteredItems = templates.filter {
            it.value.contains(keyword, ignoreCase = true)
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = dimension.spacing.space4)
                .padding(top = topPadding),
        ) {
            InputSearchText(
                modifier = Modifier.weight(1f),
                onTextChanged = { handleKeywordChanged(it) }
            )
        }
        if (isEmptyChooseTemplate) {
            TextBodySmall(
                text = stringResource(Res.string.choose_template_before_start_inspection),
                modifier = Modifier.padding(
                    horizontal = dimension.spacing.space4,
                    vertical = dimension.spacing.space3
                ),
                color = { it.error.default }
            )
        }
        if (filteredItems.isEmpty()) {
            TextBodySmall(
                text = stringResource(Res.string.not_found),
                modifier = Modifier.padding(
                    horizontal = dimension.spacing.space4,
                    vertical = dimension.spacing.space3
                ),
                color = { it.disabled }
            )
        } else {
            LazyColumn {
                items(filteredItems) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .clickable {
                                handleSelectedItem(it)
                            }
                            .padding(
                                horizontal = dimension.spacing.space4,
                                vertical = dimension.spacing.space3
                            )
                            .animateItem(),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        TextBodySmall(text = it.value)
                        if (selectedItem?.id == it.id) {
                            Icon(
                                painter = painterResource(Res.drawable.ic_check),
                                tint = color.icon.brand,
                                modifier = Modifier.size(dimension.size.icon.s),
                                contentDescription = stringResource(Res.string.icon_content_description),
                            )
                        }
                    }
                }
            }
        }
    }
}
